export default __webpack_public_path__ + "static/media/HorarioDeFuncionamento.a1afe005.svg";